// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
    /* Color Palette */
    --primary-blue: #347090;
    --primary-hover: #5486b9;
    --secondary-gray: #f8f8f8;
    --text-dark: #346d90;
    --text-medium: #374968;
    --text-light: #FEEBEE;
    --border-light: #e1e1e1;
    --secondary-light: #FCFDFD;
    --white: #F9F7EE;
    --secondary-dark:rgb(229, 246, 254);
  
    /* Spacing */
    --section-padding: 80px;
    --mobile-section-padding: 50px;
  }
  
  /* Base Reset */
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  body {
    font-family: 'Air', serif, sans-serif;
    line-height: 1.6;
    color: var(--text-dark);
    background-color: var(--secondary-light);
    overflow-x: hidden;
  }
  
  /* Typography */
  h1, h2, h3, h4 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0.75em;
    font-family: 'imperial-m';
    letter-spacing: 1.7px;
  }
  
  h1 {
    font-size: 2.8rem;
  }
  
  h2 {
    font-size: 2.2rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
  
  p {
    margin-bottom: 1.5em;
    color: var(--text-medium);
  }
  
  /* Layout Components */
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  section {
    padding: var(--section-padding) 0;
  }

  :target {
    scroll-margin-top: 80px; /* Matches your header height */
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
  }
  
  /* Buttons (Matching Original Site) */
  .button {
    display: inline-block;
    padding: 12px 25px;
    border-radius: 4px;
    font-weight: 500;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .primary-button {
    background-color: var(--primary-blue);
    color: var(--white);
    border: 2px solid var(--primary-blue);
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
  }
  
  .primary-button:hover {
    background-color: var(--primary-hover);
    border-color: var(--primary-hover);
    transform: translateY(-2px);
  }
  
  .secondary-button {
    background-color: transparent;
    color: var(--primary-blue);
    border: 2px solid var(--primary-blue);
  }
  
  .secondary-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
  
  /* Utility Classes */
  .text-center {
    text-align: center;
  }
  
  .section-title {
    position: relative;
    margin-bottom: 60px;
    padding-bottom: 15px;
  }
  
  .section-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: var(--primary-blue);
  }
  
  /* Responsive Breakpoints */
  @media (max-width: 1199px) {
    :root {
      --section-padding: 70px;
    }
    
    h1 {
      font-size: 2.5rem;
    }
  }
  
  @media (max-width: 991px) {
    :root {
      --section-padding: 60px;
    }
    
    h1 {
      font-size: 2.2rem;
    }
    
    h2 {
      font-size: 2rem;
    }
  }
  
  @media (max-width: 767px) {
    :root {
      --section-padding: var(--mobile-section-padding);
    }
    
    h1 {
      font-size: 1.8rem;
    }
    
    h2 {
      font-size: 1.6rem;
    }
    
    .section-title {
      margin-bottom: 40px;
    }
  }
  
  @media (max-width: 575px) {
    h1 {
      font-size: 1.6rem;
    }
    
    .button {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,mCAAmC;;IAEnC,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA,eAAe;EACf;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,uBAAuB,EAAE,+BAA+B;EAC1D;;EAEA;IACE;MACE,qBAAqB;IACvB;EACF;;EAEA,qCAAqC;EACrC;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;IACtC,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,qCAAqC;EACvC;;EAEA,2BAA2B;EAC3B;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,gDAAgD;IAClD;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;EACF","sourcesContent":["\n:root {\n    /* Color Palette */\n    --primary-blue: #347090;\n    --primary-hover: #5486b9;\n    --secondary-gray: #f8f8f8;\n    --text-dark: #346d90;\n    --text-medium: #374968;\n    --text-light: #FEEBEE;\n    --border-light: #e1e1e1;\n    --secondary-light: #FCFDFD;\n    --white: #F9F7EE;\n    --secondary-dark:rgb(229, 246, 254);\n  \n    /* Spacing */\n    --section-padding: 80px;\n    --mobile-section-padding: 50px;\n  }\n  \n  /* Base Reset */\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n  \n  html {\n    scroll-behavior: smooth;\n  }\n  \n  body {\n    font-family: 'Air', serif, sans-serif;\n    line-height: 1.6;\n    color: var(--text-dark);\n    background-color: var(--secondary-light);\n    overflow-x: hidden;\n  }\n  \n  /* Typography */\n  h1, h2, h3, h4 {\n    font-weight: 700;\n    line-height: 1.2;\n    margin-bottom: 0.75em;\n    font-family: 'imperial-m';\n    letter-spacing: 1.7px;\n  }\n  \n  h1 {\n    font-size: 2.8rem;\n  }\n  \n  h2 {\n    font-size: 2.2rem;\n  }\n  \n  h3 {\n    font-size: 1.5rem;\n  }\n  \n  p {\n    margin-bottom: 1.5em;\n    color: var(--text-medium);\n  }\n  \n  /* Layout Components */\n  .container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 15px;\n  }\n  \n  section {\n    padding: var(--section-padding) 0;\n  }\n\n  :target {\n    scroll-margin-top: 80px; /* Matches your header height */\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    html {\n      scroll-behavior: auto;\n    }\n  }\n  \n  /* Buttons (Matching Original Site) */\n  .button {\n    display: inline-block;\n    padding: 12px 25px;\n    border-radius: 4px;\n    font-weight: 500;\n    text-decoration: none;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .primary-button {\n    background-color: var(--primary-blue);\n    color: var(--white);\n    border: 2px solid var(--primary-blue);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: center;\n  }\n  \n  .primary-button:hover {\n    background-color: var(--primary-hover);\n    border-color: var(--primary-hover);\n    transform: translateY(-2px);\n  }\n  \n  .secondary-button {\n    background-color: transparent;\n    color: var(--primary-blue);\n    border: 2px solid var(--primary-blue);\n  }\n  \n  .secondary-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    transform: translateY(-2px);\n  }\n  \n  /* Utility Classes */\n  .text-center {\n    text-align: center;\n  }\n  \n  .section-title {\n    position: relative;\n    margin-bottom: 60px;\n    padding-bottom: 15px;\n  }\n  \n  .section-title::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 80px;\n    height: 3px;\n    background-color: var(--primary-blue);\n  }\n  \n  /* Responsive Breakpoints */\n  @media (max-width: 1199px) {\n    :root {\n      --section-padding: 70px;\n    }\n    \n    h1 {\n      font-size: 2.5rem;\n    }\n  }\n  \n  @media (max-width: 991px) {\n    :root {\n      --section-padding: 60px;\n    }\n    \n    h1 {\n      font-size: 2.2rem;\n    }\n    \n    h2 {\n      font-size: 2rem;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    :root {\n      --section-padding: var(--mobile-section-padding);\n    }\n    \n    h1 {\n      font-size: 1.8rem;\n    }\n    \n    h2 {\n      font-size: 1.6rem;\n    }\n    \n    .section-title {\n      margin-bottom: 40px;\n    }\n  }\n  \n  @media (max-width: 575px) {\n    h1 {\n      font-size: 1.6rem;\n    }\n    \n    .button {\n      padding: 10px 20px;\n      font-size: 0.9rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
